import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface ReferalsState {
  isMissedReferalsOpen: boolean;
  isUnregisteredReferalsOpen: boolean;
  isCompletedReferalsOpen: boolean;
  setIsMissedReferalsOpen: (elem: boolean) => void;
  setIsUnregisteredReferalsOpen: (elem: boolean) => void;
  setIsCompletedReferalsOpen: (elem: boolean) => void;
}

export const useReferalsStateStore = create<ReferalsState>()(
  persist(
    (set) => ({
      isMissedReferalsOpen: false,
      isUnregisteredReferalsOpen: false,
      isCompletedReferalsOpen: false,
      setIsMissedReferalsOpen: (elem) =>
        set(() => ({
          isMissedReferalsOpen: elem,
        })),
      setIsUnregisteredReferalsOpen: (elem) =>
        set(() => ({
          isUnregisteredReferalsOpen: elem,
        })),
      setIsCompletedReferalsOpen: (elem) =>
        set(() => ({
          isCompletedReferalsOpen: elem,
        })),
    }),
    {
      name: "referals-state",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
